export default function Hero() {
  return (
    <section
      id="hero"
      className="relative w-full min-h-[520px] md:min-h-[600px] flex items-center overflow-hidden bg-background-50"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-background-100/80 via-background-50/60 to-background-50/90 z-0"></div>

      <div className="relative z-10 w-full px-4 md:px-6 py-16 md:py-20">
        <div className="max-w-6xl mx-auto flex flex-col lg:flex-row items-center gap-8 md:gap-12">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-3 py-1 rounded-full text-xs font-medium bg-accent-100 text-accent-800 mb-4">
              每日更新 · 高清免费
            </span>

            <h1 className="text-2xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-900 leading-tight mb-3">
              6080影视
              <span className="block text-primary-600 text-xl md:text-3xl lg:text-4xl mt-2">
                免费高清电影在线观映平台
              </span>
            </h1>

            <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-xl lg:max-w-none mb-5">
              依托6080新视觉影视强大资源库，为您精选海量高清电影、最新院线大片与经典佳作。
              无需注册、无需VIP，打开即看，不缓冲流畅播放。每日同步更新热门影片，
              涵盖动作、喜剧、科幻、悬疑、动画等全类型，满足每一位影迷的观影需求。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4 md:gap-6 mb-6">
              <div className="flex items-center gap-2 text-sm text-foreground-600">
                <span className="w-2 h-2 rounded-full bg-accent-500"></span>
                <span>每日更新 <strong className="text-foreground-800">30+</strong> 部影片</span>
              </div>
              <div className="flex items-center gap-2 text-sm text-foreground-600">
                <span className="w-2 h-2 rounded-full bg-accent-500"></span>
                <span>片库总量 <strong className="text-foreground-800">50000+</strong> 部</span>
              </div>
              <div className="flex items-center gap-2 text-sm text-foreground-600">
                <span className="w-2 h-2 rounded-full bg-accent-500"></span>
                <span>全终端流畅播放 · 免VIP</span>
              </div>
            </div>

            <div className="flex items-center justify-center lg:justify-start gap-3">
              <a
                href="#index"
                className="inline-flex items-center gap-2 px-6 py-3 rounded-md bg-primary-500 text-background-50 font-medium text-sm hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-movie-2-line"></i>
                立即观影
              </a>
              <a
                href="#about"
                className="inline-flex items-center gap-2 px-6 py-3 rounded-md border border-foreground-200 text-foreground-700 font-medium text-sm hover:border-primary-300 hover:text-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-information-line"></i>
                了解更多
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-[480px] lg:max-w-[540px]">
            <div className="relative w-full aspect-[4/3] rounded-lg overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Cinematic%20abstract%20composition%20with%20warm%20golden%20and%20deep%20red%20accents%2C%20floating%20film%20strips%20and%20soft%20bokeh%20lights%2C%20dark%20theater%20curtains%20on%20sides%2C%20elegant%20gradient%20background%20with%20subtle%20lens%20flare%20effect%2C%20artistic%20minimalist%20movie%20aesthetic%2C%20warm%20amber%20and%20burgundy%20tones%2C%20professional%20cinematic%20atmosphere%2C%20no%20text%20no%20logos%20clean%20composition&width=1080&height=810&seq=hero-movie-2026-v1&orientation=landscape"
                alt="6080影视 - 免费高清电影在线观映平台主视觉"
                className="w-full h-full object-cover object-center"
                onError={(e) => {
                  const target = e.currentTarget;
                  target.style.display = 'none';
                  target.parentElement!.classList.add('hidden');
                }}
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/30 via-transparent to-transparent rounded-lg"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}